import NoteColumn from './NoteColumn';

export default NoteColumn;
